import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import "./mobilenav.css";
import { displayAuthModal } from "../../../AsianExchangeSrc/redux/slices/authModalSlice";
import { useDispatch, useSelector } from "react-redux";
const tabsList = {
  Home: "/cricket, /tennis, /soccer, /greyhound, /horse, /tips-and-previews",
  "In-Play": "/inplay",
  Sports: "/sports",
  "Live-Casino": "/live-casino",
};
function MobileBottomNavbar() {
  const [activeTab, setActiveTab] = useState("Home");
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    for (const label in tabsList) {
      const path = tabsList[label];
      if (path.includes(window.location.pathname)) {
        setActiveTab(label);
      }
    }
    setActiveTab();

    return () => {};
  }, [window.location]);

  const handleAccount = async () => {
    if (isLoggedIn) {
      navigate("/account");
    } else {
      dispatch(displayAuthModal("login"));
    }
  };

  return (
    <div
      className="fixed bottom-0 w-full h-[56px]flex justify-center items-center z-[2]"
      style={{
        background: "linear-gradient(-180deg, #243a48 20%, #172732 91%)",
      }}
    >
      <nav
        className="w-full h-full flex justify-center items-center z-[2] p-0"
        style={{
          background: "linear-gradient(-180deg, #243a48 20%, #172732 91%)",
        }}
      >
        <NavLink
          className={`text-white text-sm flex flex-col justify-end items-center h-[56px] min-w-[20%]`}
          style={
            tabsList.Home.includes(window.location.pathname)
              ? {
                  background:
                    "linear-gradient(-180deg,#32617f 20%,#1f4258 91%)",
                }
              : {}
          }
          onClick={() => setActiveTab("Home")}
          to="/cricket"
        >
          <img src={`/Icon/home.svg`} alt="Home" className="w-[1.8rem]" />
          <span className="max-[500px]:font-[3vw]">Home</span>
        </NavLink>
        <NavLink
          className={` text-white text-sm flex flex-col justify-end items-center h-[56px] min-w-[20%]`}
          style={
            tabsList["In-Play"].includes(window.location.pathname)
              ? {
                  background:
                    "linear-gradient(-180deg,#32617f 20%,#1f4258 91%)",
                }
              : {}
          }
          onClick={() => setActiveTab("In-Play")}
          to="/inplay"
        >
          <span className="text-[2rem]">
            <img
              src={`/Icon/timer.svg`}
              alt="timericon"
              className="w-[1.8rem]"
            />
          </span>
          <span className="min-w-12 max-[500px]:font-[3vw]">In-Play</span>
        </NavLink>

        <NavLink
          className={` 
       square-with-hemisphere text-white text-sm flex flex-col justify-end items-center h-[56px] min-w-[20%] pb-[6px]`}
          to="/sports"
          onClick={() => setActiveTab("Sports")}
          style={
            tabsList["Sports"].includes(window.location.pathname)
              ? {
                  background:
                    "linear-gradient(-180deg,#32617f 20%,#1f4258 91%)",
                }
              : {
                  background:
                    "linear-gradient(-180deg, #243a48 20%, #172732 91%)",
                }
          }
        >
          <img
            src={`/Icon/trophy.svg`}
            alt="trophyicon"
            className="w-[1.8rem]"
          />
          <span className="max-[500px]:font-[3vw]">Sports</span>
        </NavLink>

        <NavLink
          className={`
       text-white text-sm flex flex-col justify-end items-center h-[56px] min-w-[20%]`}
          style={
            tabsList["Live-Casino"].includes(window.location.pathname)
              ? {
                  background:
                    "linear-gradient(-180deg,#32617f 20%,#1f4258 91%)",
                }
              : {
                  background:
                    "linear-gradient(-180deg, #243a48 20%, #172732 91%)",
                }
          }
          onClick={() => setActiveTab("Live-Casino")}
          to={"/live-casino"}
        >
          <img
            src={`/Icon/mini_games.gif`}
            alt="pinicon"
            className="w-[1.8rem]"
          />
          <span className="min-w-[70px] font-[3vw] text-center">Casino</span>
        </NavLink>
        <NavLink
          className={`text-white text-sm flex flex-col justify-end items-center h-[56px] min-w-[20%]`}
          to={"#"}
          onClick={handleAccount}
        >
          <img src={`/Icon/user.svg`} alt="usericon" className="w-[1.8rem]" />
          <span className="max-[500px]:font-[3vw]">Account</span>
        </NavLink>
      </nav>
    </div>
  );
}

export default MobileBottomNavbar;
